export const QUICK_TIMER_STORAGE_KEY = 'milo.quickTimer.v1';
export const QUICK_TIMER_RECENT_PROJECTS_KEY = 'milo.quickTimer.recentProjects.v1';
export const QUICK_TIMER_ACTIVE_SESSION_KEY = 'milo.quickTimer.activeSession.v1';
